import { render, staticRenderFns } from "./katex.vue?vue&type=template&id=0d48ae7c&scoped=true&"
import script from "./katex.vue?vue&type=script&lang=js&"
export * from "./katex.vue?vue&type=script&lang=js&"
import style0 from "./katex.vue?vue&type=style&index=0&id=0d48ae7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48ae7c",
  null
  
)

export default component.exports